import { all } from "redux-saga/effects";
import { dichVuThongTinSaga } from "./dichVuThongTinSaga";
import { dichVuHoSoSaga } from "./dichVuHoSoSaga";
import { dichVuThanhToanSaga } from "./dichVuThanhToanSaga";

export default function* dichVuSaga() {
  yield all([dichVuThongTinSaga(), dichVuHoSoSaga(), dichVuThanhToanSaga()]);
}
